import {FC} from 'react'

type PropsBodyChildren = {
  product: string | undefined
  assign: string | undefined
  created_at: string | undefined
}
const BodyChildren: FC<PropsBodyChildren> = ({product, assign, created_at}) => {

  return (
    <>
      <div className="fs-6 mt-2 d-flex flex-column flex-md-row">
        <div className="fw-semibold text-gray-600">
          Services:
          <span className="text-muted ms-1 me-3">{product}</span>
        </div>
        <div className="fw-semibold text-gray-600 mx-0 mx-md-3 my-1 my-md-0">
          Détails:
          <span className="text-muted ms-1 me-3">{assign}</span>
        </div>
        <div className="fw-semibold text-gray-600">Créé le:
          <span className="text-muted ms-1 me-3">{created_at}</span>
        </div>
      </div>
    </>
  )
}

export {BodyChildren}